// extracted by mini-css-extract-plugin
module.exports = {"textareaWrapper":"LoyaltyContactFormTextArea_textareaWrapper__ppFY6"};